import { createContext, useState, useEffect } from "react";

export const DeviceWidthContext = createContext();

export function DeviceWidthContextProvider(props) {
  const [deviceWidth, setDeviceWidth] = useState(null);
  const [mobileNavActive, setMobileNavActive] = useState(false);


  const toggleMobileNav = async (param) => {
    setMobileNavActive(param);
  };

  const handleResize = () => {
    setDeviceWidth(window.innerWidth);
  };

  useEffect(() => {
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);



  return (
    <DeviceWidthContext.Provider
      value={{
        deviceWidth,
        toggleMobileNav,
        mobileNavActive,
      }}
    >
      {props.children}
    </DeviceWidthContext.Provider>
  );
}
